export const cardStyle = { background: "white", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", padding: "28px", marginBottom: "20px" };

export const cardTitleStyle = { fontSize: "16px", fontWeight: 600, color: "#111827", margin: 0, marginBottom: "20px" };

export const countBadgeStyle = { background: "#f3f4f6", color: "#6b7280", fontSize: "12px", fontWeight: 600, borderRadius: "12px", padding: "1px 8px" };

export const fieldStyle = { display: "flex", flexDirection: "column" };
// display block : un <label> en ligne ignore sa marge basse et le contour de focus du champ touche alors le libellé.

export const labelStyle = { display: "block", fontSize: "12px", fontWeight: 600, color: "#6b7280", marginBottom: "6px" };

export const inputStyle = { padding: "9px 12px", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", boxSizing: "border-box", width: "100%", color: "#111827", background: "white" };

export const btnBlackStyle = { padding: "10px 20px", background: "#111827", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 };

export const btnOutlineStyle = { padding: "7px 14px", background: "transparent", color: "#374151", border: "1px solid #d1d5db", borderRadius: "7px", cursor: "pointer", fontSize: "13px", fontWeight: 500, whiteSpace: "nowrap" };

export const btnOutlineDangerStyle = { padding: "7px 14px", background: "transparent", color: "#dc2626", border: "1px solid #fca5a5", borderRadius: "7px", cursor: "pointer", fontSize: "13px", fontWeight: 500, whiteSpace: "nowrap" };

export const btnPurpleOutlineStyle = { padding: "7px 14px", background: "transparent", color: "#6c4de6", border: "1px solid #c4b5fd", borderRadius: "7px", cursor: "pointer", fontSize: "13px", fontWeight: 500, whiteSpace: "nowrap" };

export const btnPurpleFilledStyle = { padding: "10px 20px", background: "#6c4de6", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: 600, whiteSpace: "nowrap" };

export const tableStyle = { width: "100%", borderCollapse: "collapse" };

export const thStyle = { textAlign: "left", padding: "8px 12px", borderBottom: "1.5px solid #f3f4f6", fontSize: "11px", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px" };

export const tdStyle = { padding: "14px 12px", fontSize: "14px", color: "#374151" };

export const errorStyle = { color: "#dc2626", fontSize: "13px", marginTop: "8px", marginBottom: 0 };

export const modalBackdropStyle = { position: "fixed", inset: 0, background: "rgba(17,24,39,0.42)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" };

export const modalStyle = { background: "white", borderRadius: "16px", boxShadow: "0 20px 45px rgba(15,23,42,0.24)", width: 480, maxWidth: "100%", padding: "24px" };

export const modalHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px" };

export const modalCloseButtonStyle = { border: "none", background: "#f3f4f6", borderRadius: "999px", width: "30px", height: "30px", cursor: "pointer", fontSize: "18px", color: "#374151" };

export const modalSecondaryButtonStyle = { padding: "9px 16px", borderRadius: "8px", border: "1px solid #d1d5db", background: "white", color: "#374151", fontSize: "14px", fontWeight: 600, cursor: "pointer" };

export const modalDangerButtonStyle = { padding: "9px 16px", borderRadius: "8px", border: "none", background: "#dc2626", color: "white", fontSize: "14px", fontWeight: 700, cursor: "pointer" };

export const therapeuticPageStyle = {
    fontFamily: "Manrope, Arial, Helvetica, sans-serif",
    color: "#122A26",
};

export const therapeuticPanelStyle = {
    background: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid rgba(12,59,60,.12)",
    boxShadow: "0 1px 2px rgba(12,59,60,.05)",
    padding: "28px",
    marginBottom: "20px",
};

export const therapeuticHeaderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    marginBottom: "18px",
    flexWrap: "wrap",
};

export const therapeuticTitleStyle = {
    margin: 0,
    color: "#0C3B3C",
    fontFamily: "Fraunces, Georgia, serif",
    fontSize: "24px",
    fontWeight: 700,
    letterSpacing: 0,
};

export const therapeuticCountBadgeStyle = {
    background: "#F4F1EA",
    color: "#0C3B3C",
    border: "1px solid rgba(12,59,60,.12)",
    fontSize: "12px",
    fontWeight: 800,
    borderRadius: "999px",
    padding: "3px 10px",
};

export const therapeuticFiltersStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "14px",
    alignItems: "end",
    padding: "16px",
    marginBottom: "18px",
    borderRadius: "8px",
    background: "#F4F1EA",
    border: "1px solid rgba(12,59,60,.10)",
};

export const therapeuticFilterLabelStyle = {
    color: "#0C3B3C",
    fontWeight: 800,
};

export const therapeuticInputStyle = {
    padding: "10px 12px",
    border: "1px solid rgba(12,59,60,.22)",
    borderRadius: "8px",
    fontSize: "14px",
    boxSizing: "border-box",
    width: "100%",
    color: "#122A26",
    background: "white",
    fontFamily: "Manrope, Arial, Helvetica, sans-serif",
};

export const therapeuticFormGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "14px",
};

export const therapeuticPrimaryButtonStyle = {
    padding: "10px 20px",
    background: "#0C3B3C",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 800,
    whiteSpace: "nowrap",
};

export const therapeuticSecondaryButtonStyle = {
    padding: "8px 14px",
    background: "transparent",
    color: "#0C3B3C",
    border: "1px solid rgba(12,59,60,.28)",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 800,
    whiteSpace: "nowrap",
};

export const therapeuticDangerButtonStyle = {
    padding: "8px 14px",
    background: "transparent",
    color: "#b91c1c",
    border: "1px solid #fecaca",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 800,
    whiteSpace: "nowrap",
};

export const therapeuticTableStyle = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
};

export const therapeuticThStyle = {
    textAlign: "left",
    padding: "10px 12px",
    borderBottom: "1.5px solid rgba(12,59,60,.14)",
    fontSize: "11px",
    fontWeight: 800,
    color: "#5A6D68",
    textTransform: "uppercase",
    letterSpacing: 0,
};
